import React from 'react';

import { CanCreateOfflinePo, RequireExistingPo } from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';
import RequirePermissionWizard from 'src/sections/enter_invoice/enter_invoice_wizard/RequirePermissionWizard';
import CreatePo from './CreatePo';
import CreateReceipt from './CreateReceipt';

interface IProps {
  openModal: boolean;
  closeModal: () => void;
}
export const permissionMessage = (isInvoice: boolean) => (
  <p>
    Please contact another user in your organization that has the ability to create Purchase Orders,
    and request that they create a Purchase Order so that a {`${isInvoice ? 'invoice' : 'receipt'}`}{' '}
    can be created for it. Please contact Customer Support to submit a request for access.
  </p>
);

const CreateReceiptWithoutPoWizard: React.FC<IProps> = ({ openModal, closeModal }) => {
  const hasPermissionToCreateOfflinePo = usePermission({ permissions: CanCreateOfflinePo });
  const hasPermissionToRequireExistingPo = usePermission({ permissions: RequireExistingPo });
  let defaultRendering: React.ReactElement<any> | null = null;

  if (hasPermissionToRequireExistingPo && hasPermissionToCreateOfflinePo) {
    defaultRendering = <CreatePo openModal={openModal} closeModal={closeModal} />;
  } else if (hasPermissionToCreateOfflinePo) {
    defaultRendering = <CreateReceipt openModal={openModal} closeModal={closeModal} />;
  } else if (hasPermissionToCreateOfflinePo) {
    defaultRendering = <CreatePo openModal={openModal} closeModal={closeModal} />;
  } else {
    defaultRendering = (
      <RequirePermissionWizard
        title={'Cannot Create PO'}
        openModal={openModal}
        closeModal={closeModal}
        content={permissionMessage(false)}
      />
    );
  }

  return defaultRendering;
};

export default CreateReceiptWithoutPoWizard;
